module.exports = "./img/6b0eb6f1ddedf29bdfe7b1471e1816ba.jpg";